import { useIntl } from 'react-intl';

import { LoggedOutConfluenceBlueWaveTemplate } from '../../components/logged-out-confluence-blue-wave-template';

export const LoggedOutConfluenceStandard = () => {
	const { formatMessage } = useIntl();

	return (
		<LoggedOutConfluenceBlueWaveTemplate
			productEditionText={formatMessage({
				id: 'WacSignupHeader.cloudStandard',
				defaultMessage: 'Cloud Standard',
			})}
		/>
	);
};
